import { Book, Endpoints } from "@brg/api";
import { FC, ReactNode, useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { BookEvents } from "../helper/bookEvents";
import { StyledDropdownListItem } from "shared/components/tooltips/ProjectTooltip";
import { AppTester } from "supporting";
import { BookDelegate } from "../../book-delegate";
import { useProfile } from "@brg/auth";
import { RequestPublicationModal } from "shared/modals/RequestPublicationModal/RequestPublicationModal";
import { createPortal } from "react-dom";
import { computeProjectBook } from "../helper/types/computed/ComputedBook";

export interface BookTooltipProps {
  isViewable?: boolean;
  isPublishable?: boolean;
  isDeletable?: boolean;
  isEditable?: boolean;
  isCanBeDraft?: boolean;
  isModerately?: boolean;
  identifier?: string;
  isReportable?: boolean;
  isTagModerator?: boolean;
  isCanNotParticipate?: boolean;
  onNotParticipate?: (projectId: string) => void;
  children?: ReactNode;
  repostTools?: any;
  book?: Book | Book<'Global'>;
}

/**
 * **BookTooltip** - контент всплывающего меню со всеми необходимыми параметрами и настройками для книги.
 *
 * @param props
 */
export const BookTooltip: FC<BookTooltipProps & BookEvents> = (props) => {
  const { t } = useTranslation();
  const profile = useProfile();
  const [showRequestPublicationModal, setShowRequestPublicationModal] = useState(false);

  const {
    isViewable,
    isPublishable,
    isEditable,
    isReportable,
    isDeletable,
    isCanBeDraft,
    identifier,
    isModerately,
    isTagModerator,
    isCanNotParticipate,
    children,
    repostTools,
    book,
    onRemoveFromFeed,
    onBookPublish,
    onBookDelete,
    onBookEdit,
    onBookMoveDrafts,
    onBookMoveModerate,
    onBookReport,
    onBookView,
    onNotParticipate,
  } = props;

  const isContinuumSite = AppTester.isContinuumSite();

  const isOwner = useMemo(() => profile?.accountId === book?.authorId || profile?.accountId === book?.creatorId, [profile?.accountId, book?.authorId, book?.creatorId]);
  const isCoauthor = useMemo(() => book?.coAuthorIds?.includes(profile?.accountId ?? ''), [book?.coAuthorIds, profile?.accountId]);
  const isRejected = useMemo(() => BookDelegate.isRejectedBook(book), [book]);

  const projectFromBook = useMemo(() => {
    if (!book) return undefined;
    // @ts-ignore
    return computeProjectBook(book) as any;
  }, [book]);

  const handleRequestPublication = useCallback(() => {
    if (!book?.bookId) return;
  }, [book?.bookId]);

  const handleOpenRequestPublicationModal = useCallback((e?: React.MouseEvent) => {
    e?.stopPropagation();
    e?.preventDefault();
    if (!book?.bookId) {
      return;
    }
    setShowRequestPublicationModal(true);
  }, [book?.bookId]);

  const fireEvent = (handler?: (s: string) => void) => (ev: React.MouseEvent) => {
    ev.preventDefault();
    ev.stopPropagation();
    handler?.(identifier ?? '');
  };

  const fireOpen = (ev: React.MouseEvent) => {
    ev.preventDefault();
    ev.stopPropagation()
    window.open((Endpoints.geograffee + "/api/Project/GetStatisticForProjest?projectId=" + identifier), '_blank')?.focus();
  };
 
  return (
    <>
        {isViewable && (
          <StyledDropdownListItem isContinuumSite={isContinuumSite} onClick={fireEvent(onBookView)}>{t('view').toLowerCase()}</StyledDropdownListItem>
        )}
        {isEditable && (
          <StyledDropdownListItem isContinuumSite={isContinuumSite} onClick={fireEvent(onBookEdit)}>{t('edit').toLowerCase()}</StyledDropdownListItem>
        )}
        {isPublishable && (
          <StyledDropdownListItem isContinuumSite={isContinuumSite} onClick={fireEvent(onBookPublish)}>{t('publish').toLowerCase()}</StyledDropdownListItem>
        )}
        {isCanBeDraft && !((isOwner || isCoauthor) && book && isRejected) && (
          <StyledDropdownListItem isContinuumSite={isContinuumSite} onClick={fireEvent(onBookMoveDrafts)}>{t('move_drafts').toLowerCase()}</StyledDropdownListItem>
        )}
        {isModerately && (
          <StyledDropdownListItem isContinuumSite={isContinuumSite} onClick={fireEvent(onBookMoveModerate)}>{t('moderate').toLowerCase()}</StyledDropdownListItem>
        )}
        {isDeletable && (
          <StyledDropdownListItem isContinuumSite={isContinuumSite} onClick={fireEvent(onBookDelete)}>{t('delete').toLowerCase()}</StyledDropdownListItem>
        )}
        {isReportable && (
          <StyledDropdownListItem isContinuumSite={isContinuumSite} onClick={fireEvent(onBookReport)}>{t('send_report').toLowerCase()}</StyledDropdownListItem>
        )}
        {isTagModerator && (
          <StyledDropdownListItem isContinuumSite={isContinuumSite} onClick={fireOpen}>{t('moder_log').toLowerCase()}</StyledDropdownListItem>
        )}
        {isCanNotParticipate && (
          <StyledDropdownListItem isContinuumSite={isContinuumSite} onClick={fireEvent(onNotParticipate)}>{t('not_participate').toLowerCase()}</StyledDropdownListItem>
        )}
        {(isOwner || isCoauthor) && book && isRejected && (
          <StyledDropdownListItem 
            isContinuumSite={isContinuumSite} 
            onClick={handleOpenRequestPublicationModal}
          >
            {t('project_edit.request_publication')}
          </StyledDropdownListItem>
        )}
        {children}
        {showRequestPublicationModal && projectFromBook && (
          createPortal(
            <RequestPublicationModal 
              project={projectFromBook}
              onConfirm={handleRequestPublication}
              onCancel={() => setShowRequestPublicationModal(false)}
            />,
            document.body
          )
        )}
    </>
  );
};
import { Book, Endpoints } from "@brg/api";
import { FC, ReactNode, useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { BookEvents } from "../helper/bookEvents";
import { StyledDropdownListItem } from "shared/components/tooltips/ProjectTooltip";
import { AppTester } from "supporting";
import { BookDelegate } from "../../book-delegate";
import { useProfile } from "@brg/auth";
import { RequestPublicationModal } from "shared/modals/RequestPublicationModal/RequestPublicationModal";
import { createPortal } from "react-dom";
import { computeProjectBook } from "../helper/types/computed/ComputedBook";

export interface BookTooltipProps {
  isViewable?: boolean;
  isPublishable?: boolean;
  isDeletable?: boolean;
  isEditable?: boolean;
  isCanBeDraft?: boolean;
  isModerately?: boolean;
  identifier?: string;
  isReportable?: boolean;
  isTagModerator?: boolean;
  isCanNotParticipate?: boolean;
  onNotParticipate?: (projectId: string) => void;
  children?: ReactNode;
  repostTools?: any;
  book?: Book | Book<'Global'>;
}

/**
 * **BookTooltip** - контент всплывающего меню со всеми необходимыми параметрами и настройками для книги.
 *
 * @param props
 */
export const BookTooltip: FC<BookTooltipProps & BookEvents> = (props) => {
  const { t } = useTranslation();
  const profile = useProfile();
  const [showRequestPublicationModal, setShowRequestPublicationModal] = useState(false);

  const {
    isViewable,
    isPublishable,
    isEditable,
    isReportable,
    isDeletable,
    isCanBeDraft,
    identifier,
    isModerately,
    isTagModerator,
    isCanNotParticipate,
    children,
    repostTools,
    book,
    onRemoveFromFeed,
    onBookPublish,
    onBookDelete,
    onBookEdit,
    onBookMoveDrafts,
    onBookMoveModerate,
    onBookReport,
    onBookView,
    onNotParticipate,
  } = props;

  const isContinuumSite = AppTester.isContinuumSite();

  const isOwner = useMemo(() => profile?.accountId === book?.authorId || profile?.accountId === book?.creatorId, [profile?.accountId, book?.authorId, book?.creatorId]);
  const isCoauthor = useMemo(() => book?.coAuthorIds?.includes(profile?.accountId ?? ''), [book?.coAuthorIds, profile?.accountId]);
  const isRejected = useMemo(() => BookDelegate.isRejectedBook(book), [book]);

  const projectFromBook = useMemo(() => {
    if (!book) return undefined;
    // @ts-ignore
    return computeProjectBook(book) as any;
  }, [book]);

  const handleRequestPublication = useCallback(() => {
    if (!book?.bookId) return;
  }, [book?.bookId]);

  const handleOpenRequestPublicationModal = useCallback((e?: React.MouseEvent) => {
    e?.stopPropagation();
    e?.preventDefault();
    if (!book?.bookId) {
      return;
    }
    setShowRequestPublicationModal(true);
  }, [book?.bookId]);

  const fireEvent = (handler?: (s: string) => void) => (ev: React.MouseEvent) => {
    ev.preventDefault();
    ev.stopPropagation();
    handler?.(identifier ?? '');
  };

  const fireOpen = (ev: React.MouseEvent) => {
    ev.preventDefault();
    ev.stopPropagation()
    window.open((Endpoints.geograffee + "/api/Project/GetStatisticForProjest?projectId=" + identifier), '_blank')?.focus();
  };
 
  return (
    <>
        {isViewable && (
          <StyledDropdownListItem isContinuumSite={isContinuumSite} onClick={fireEvent(onBookView)}>{t('view').toLowerCase()}</StyledDropdownListItem>
        )}
        {isEditable && (
          <StyledDropdownListItem isContinuumSite={isContinuumSite} onClick={fireEvent(onBookEdit)}>{t('edit').toLowerCase()}</StyledDropdownListItem>
        )}
        {isPublishable && (
          <StyledDropdownListItem isContinuumSite={isContinuumSite} onClick={fireEvent(onBookPublish)}>{t('publish').toLowerCase()}</StyledDropdownListItem>
        )}
        {isCanBeDraft && !((isOwner || isCoauthor) && book && isRejected) && (
          <StyledDropdownListItem isContinuumSite={isContinuumSite} onClick={fireEvent(onBookMoveDrafts)}>{t('move_drafts').toLowerCase()}</StyledDropdownListItem>
        )}
        {isModerately && (
          <StyledDropdownListItem isContinuumSite={isContinuumSite} onClick={fireEvent(onBookMoveModerate)}>{t('moderate').toLowerCase()}</StyledDropdownListItem>
        )}
        {isDeletable && (
          <StyledDropdownListItem isContinuumSite={isContinuumSite} onClick={fireEvent(onBookDelete)}>{t('delete').toLowerCase()}</StyledDropdownListItem>
        )}
        {isReportable && (
          <StyledDropdownListItem isContinuumSite={isContinuumSite} onClick={fireEvent(onBookReport)}>{t('send_report').toLowerCase()}</StyledDropdownListItem>
        )}
        {isTagModerator && (
          <StyledDropdownListItem isContinuumSite={isContinuumSite} onClick={fireOpen}>{t('moder_log').toLowerCase()}</StyledDropdownListItem>
        )}
        {isCanNotParticipate && (
          <StyledDropdownListItem isContinuumSite={isContinuumSite} onClick={fireEvent(onNotParticipate)}>{t('not_participate').toLowerCase()}</StyledDropdownListItem>
        )}
        {(isOwner || isCoauthor) && book && isRejected && (
          <StyledDropdownListItem 
            isContinuumSite={isContinuumSite} 
            onClick={handleOpenRequestPublicationModal}
          >
            {t('project_edit.request_publication')}
          </StyledDropdownListItem>
        )}
        {children}
        {showRequestPublicationModal && projectFromBook && (
          createPortal(
            <RequestPublicationModal 
              project={projectFromBook}
              onConfirm={handleRequestPublication}
              onCancel={() => setShowRequestPublicationModal(false)}
            />,
            document.body
          )
        )}
    </>
  );
};
